import * as React from "react";
import type { SVGProps } from "react";
const SvgVayuLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={22}
    fill="none"
    viewBox="0 0 64 22" {...props}
  >
    <path
      fill="#F7F9FF"
      d="M13.568.504 9.744 10.857c-.68 1.84-2.243 1.84-2.922 0L2.998.504H0L4.688 12.63c.651 2.009 2.1 2.747 3.537 2.747s2.756-.672 3.712-2.844L16.617.504zM29.202 2.12A7.92 7.92 0 0 0 23.796 0c-4.343 0-7.875 3.472-7.875 7.741s3.532 7.742 7.875 7.742a7.92 7.92 0 0 0 5.406-2.121v1.696h2.514V.542h-2.514zm-5.406 10.852c-2.934 0-5.321-2.346-5.321-5.23 0-2.886 2.386-5.23 5.32-5.23s5.322 2.346 5.322 5.23c0 2.883-2.387 5.23-5.321 5.23M61.498.516V9q0 1.113-.55 2.019a4.1 4.1 0 0 1-1.46 1.427q-.016.005-.028.012a4 4 0 0 1-2.04.535q-1.13-.001-2.041-.535-.015-.007-.027-.012a4.06 4.06 0 0 1-1.461-1.427A3.8 3.8 0 0 1 53.34 9V.513h-2.499V9.54q0 1.653.81 2.998.81 1.344 2.187 2.142c.917.53 2.092.798 3.829.798 1.11 0 2.418-.266 3.335-.798a6.05 6.05 0 0 0 2.187-2.142Q64 11.194 64 9.54V.516zM46.473 8.3V.576h2.628v14.19c0 2.164-1.14 3.706-2.628 5.214A7.88 7.88 0 0 1 41.185 22q-.64-.001-1.253-.098v-2.576q.608.152 1.253.153c2.746 0 5.016-2.07 5.288-4.713v-1.251a7.88 7.88 0 0 1-5.288 2.02 7.9 7.9 0 0 1-5.307-2.037 7.7 7.7 0 0 1-2.565-5.733V.58h2.565v7.52c.176 2.74 2.56 4.912 5.307 4.912 2.746 0 5.016-2.069 5.288-4.713"
    />
  </svg>
);
export default SvgVayuLogo;
